import { useEffect } from 'react';
import Cookies from 'js-cookie';

// Backstop for cookies Cookiebot's declaration may not cover. These were written
// either host-only or on .talkpal.ai, and remove() only matches the exact domain.
const MARKETING_COOKIES = ['_fbp', '_fbc', '_uetsid', '_uetvid', 'MUID'];

const removeCookies = (names: string[]) =>
  names.forEach((name) => {
    Cookies.remove(name, { path: '/' });
    Cookies.remove(name, { path: '/', domain: '.talkpal.ai' });
  });

const CookieConsentManager = () => {
  useEffect(() => {
    const onConsent = () => {
      if (typeof window === 'undefined') return;

      const marketing = window.Cookiebot?.consent?.marketing;
      const statistics = window.Cookiebot?.consent?.statistics;

      // Consent-mode UPDATES are Cookiebot-owned: uc.js pushes gtag('consent','update')
      // and uetq.push('consent','update') itself on every load and every submission.
      // The site only declares the denied defaults (see public/index.html).
      if (window.fbq) {
        window.fbq('consent', marketing ? 'grant' : 'revoke');
      }

      if (!marketing) removeCookies(MARKETING_COOKIES);
      if (!statistics)
        removeCookies([
          '_ga',
          '_clck',
          '_clsk',
          ...document.cookie
            .split('; ')
            .map((cookie) => cookie.split('=')[0])
            .filter((name) => name.startsWith('_ga_')),
        ]);
    };

    // Listen to Cookiebot consent events
    window.addEventListener('CookiebotOnConsentReady', onConsent);
    window.addEventListener('CookiebotOnAccept', onConsent);
    window.addEventListener('CookiebotOnDecline', onConsent);

    // Cookiebot.withdraw() and the widget's withdrawal dispatch NO window event — they
    // call only this global. Safe to point straight at onConsent: it is idempotent
    // (cookie removals + an fbq revoke) and reads the live consent state itself.
    window.CookiebotCallback_OnDecline = onConsent;

    return () => {
      window.removeEventListener('CookiebotOnConsentReady', onConsent);
      window.removeEventListener('CookiebotOnAccept', onConsent);
      window.removeEventListener('CookiebotOnDecline', onConsent);
      delete window.CookiebotCallback_OnDecline;
    };
  }, []);

  return null;
};

export default CookieConsentManager;
